module.exports = __webpack_public_path__ + "assets/HeronDetailed.8a5f39e1676f2d2d19b1a43998ce8e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/HeronDetailed.png
// module id = 520
// module chunks = 0